import api from "./client";
import type { ApiResponse } from "#/types/api";
import type { DataHealthReport } from "#/types/dataHealth";

/** Data Health. Client users read their own client; a TMA admin passes `clientId`. */
export const dataHealthApi = {
  getReport: (clientId?: number): Promise<ApiResponse<DataHealthReport>> =>
    api.get("/data-health", { params: clientId ? { clientId } : undefined }),
};
